/* global google */

import $ from 'jquery';
import MarkerClusterer from '@googlemaps/markerclustererplus';

import {
  i18n, warn, parseTemplate, ajaxSettings,
} from '../common/helpers';
import Office from './Office';

class Location {
  constructor($element, {
    points, zip, country, message, center = [0, 0], onRefresh = () => {},
    finder = false,
    searchWidgetClass = 'SearchBox',
  }) {
    this.$el = $element;

    this.$title = $('.js-location-title');
    this.$map = this.$el.find('.location__map');
    this.$search = this.$el.find('.location-search__input');
    this.$gps = this.$el.find('.location-search__button_gps');
    this.$reload = this.$el.find('.location-search__button_reload');
    this.$list = this.$el.find('.location__list');
    this.$noPudo = $('#no-pudo-message');

    this.officeTemplate = $('#location__office-template').html();
    this.lastOfficePosition = null;

    this.geocoder = new google.maps.Geocoder();
    this.zoom = this.constructor.MIN_ZOOM;
    this.country = country;
    this.countryBounds = null;
    this.prevRequest = {
      [this.$search.is('input') ? 'address' : 'zip']: zip,
    };
    this.onRefresh = onRefresh;
    this.finder = finder;
    this.searchWidgetClass = searchWidgetClass;

    this.userAddress = new google.maps.LatLng(center[0], center[1]);

    this.initMap();
    this.handleReload();
    this.handleAutocomplete();
    this.handleUserLocation();
    this.setMap(message, new google.maps.LatLng(center[0], center[1]), points);

    const self = this;
    this.$list.on(`change${this.constructor.NAMESPACE}`, '.location__office', function officeChange() {
      const marker = $(this).data('office').getMarker();

      if (marker) {
        self.map.panTo(marker.position);
      }
    });
  }

  initMap() {
    this.map = new google.maps.Map(this.$map[0], {
      center: new google.maps.LatLng(0, 0),
      zoom: this.zoom || this.constructor.MIN_ZOOM,
      mapTypeControl: true,
      streetViewControl: false,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
      },
    });

    this.map.addListener('idle', () => {
      this.center = this.map.getCenter();
      this.zoom = this.map.getZoom();
    });

    this.markers = [];

    this.markerCluster = new MarkerClusterer(this.map, this.markers, {
      ignoreHidden: true,
      gridSize: 80,
      maxZoom: 14,
      styles: [
        {
          width: 35,
          height: 35,
          className: 'cluster-icon-s',
        },
        {
          width: 40,
          height: 40,
          className: 'cluster-icon-m',
        },
        {
          width: 45,
          height: 45,
          className: 'cluster-icon-l',
        },
      ],
      clusterClass: 'cluster-icon',
    });
  }

  getAddressMarker() {
    const width = 32;
    const height = 32;
    const scale = 1.5;
    const svg = `<svg width="${width * scale}" height="${height * scale}" viewBox="0 0 ${width} ${height}" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 29C17 29.5523 16.5523 30 16 30C15.4477 30 15 29.5523 15 29C15 28.4477 15.4477 28 16 28C16.5523 28 17 28.4477 17 29Z" fill="#E72F70"/><path d="M13.1622 8.47674C13.1622 6.64274 14.3601 5 16 5C17.6399 5 18.8378 6.64274 18.8378 8.47674C18.8378 10.3107 17.6399 11.9535 16 11.9535C14.3601 11.9535 13.1622 10.3107 13.1622 8.47674Z" fill="#E72F70"/><path d="M12.705 13.4399C13.5812 13.0723 14.7463 12.8605 16 12.8605C17.2537 12.8605 18.4188 13.0723 19.295 13.4399C19.7306 13.6226 20.1301 13.8584 20.4327 14.1586C20.7346 14.458 21 14.886 21 15.4302C21 15.9745 20.7346 16.4024 20.4327 16.7018C20.1301 17.002 19.7306 17.2379 19.295 17.4206C18.4188 17.7881 17.2537 18 16 18C14.7463 18 13.5812 17.7881 12.705 17.4206C12.2694 17.2379 11.8699 17.002 11.5673 16.7018C11.2654 16.4024 11 15.9745 11 15.4302C11 14.886 11.2654 14.458 11.5673 14.1586C11.8699 13.8584 12.2694 13.6226 12.705 13.4399Z" fill="#E72F70"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5 12C5 5.92487 9.92487 1 16 1C22.0751 1 27 5.92487 27 12C27 17.3921 23.1202 21.8781 18 22.8186C16.743 23.0495 16.5458 24.6418 16.4032 25.793C16.3189 26.4736 16.2537 27 16 27C15.7463 27 15.6811 26.4736 15.5968 25.793C15.4542 24.6418 15.257 23.0495 14 22.8186C8.87976 21.8781 5 17.3921 5 12ZM16 21C20.9706 21 25 16.9706 25 12C25 7.02944 20.9706 3 16 3C11.0294 3 7 7.02944 7 12C7 16.9706 11.0294 21 16 21Z" fill="#E72F70"/><path fill-rule="evenodd" clip-rule="evenodd" d="M25 12C25 16.9706 20.9706 21 16 21C11.0294 21 7 16.9706 7 12C7 7.02944 11.0294 3 16 3C20.9706 3 25 7.02944 25 12ZM16 5C14.3601 5 13.1622 6.64274 13.1622 8.47674C13.1622 10.3107 14.3601 11.9535 16 11.9535C17.6399 11.9535 18.8378 10.3107 18.8378 8.47674C18.8378 6.64274 17.6399 5 16 5ZM16 12.8605C14.7463 12.8605 13.5812 13.0723 12.705 13.4399C12.2694 13.6226 11.8699 13.8584 11.5673 14.1586C11.2654 14.458 11 14.886 11 15.4302C11 15.9745 11.2654 16.4024 11.5673 16.7018C11.8699 17.002 12.2694 17.2379 12.705 17.4206C13.5812 17.7881 14.7463 18 16 18C17.2537 18 18.4188 17.7881 19.295 17.4206C19.7306 17.2379 20.1301 17.002 20.4327 16.7018C20.7346 16.4024 21 15.9745 21 15.4302C21 14.886 20.7346 14.458 20.4327 14.1586C20.1301 13.8584 19.7306 13.6226 19.295 13.4399C18.4188 13.0723 17.2537 12.8605 16 12.8605Z" fill="white"/></svg>`;

    return new google.maps.Marker({
      position: this.userAddress,
      map: this.map,
      icon: {
        scale,
        url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(svg),
        anchor: new google.maps.Point(width / 2 * scale, height * scale),
      },
      title: i18n('Your address'),
      zIndex: 999,
    });
  }

  getUserMarker() {
    return new google.maps.Marker({
      position: this.userLocation,
      map: this.map,
      icon: {
        path: 'M7 6a3 3 0 0 1 0-6 3 3 0 0 1 0 6zM7 7C3.13 7 0 10.13 0 14c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z',
        fillColor: '#000',
        fillOpacity: 1,
        scale: 1.35,
        strokeColor: '#fff',
        strokeWeight: 0.5,
        anchor: new google.maps.Point(7, 27),
      },
      title: i18n('Your location'),
    });
  }

  getCountryBounds() {
    const dfd = $.Deferred();

    if (this.countryBounds) {
      dfd.resolve(this.countryBounds);
    } else {
      this.geocoder.geocode({
        address: this.country,
      }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          dfd.resolve(results[0].geometry.viewport);
        }

        dfd.reject(`Geocoder failed to get country info. Status: ${status}`);
      });
    }

    return dfd.promise();
  }

  getIcon(serviceID) {
    const width = 36;
    const height = 50;
    const scale = 1;
    const svg = `<svg width="${width * scale}" height="${height * scale}" viewBox="0 0 ${width} ${height}" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.8405 48.367L18 45L20.1595 48.367L18 49.752L15.8405 48.367ZM18 45C18 45 4 36.0208 4 17.9174C4 10.231 10.268 4 18 4C25.732 4 32 10.231 32 17.9174C32 36.0208 18 45 18 45ZM20.1627 48.365C20.1627 48.365 20.1595 48.367 18 45C15.8405 48.367 15.8373 48.365 15.8373 48.365L15.8338 48.3627L15.8259 48.3576L15.8061 48.3447L15.7513 48.3087C15.7082 48.2802 15.6519 48.2424 15.5835 48.1956C15.4465 48.1018 15.2604 47.9713 15.0321 47.8038C14.576 47.4692 13.9495 46.9854 13.2098 46.3516C11.7338 45.0868 9.78631 43.2066 7.84055 40.7006C3.94025 35.6774 0 28.0674 0 17.9174C0 7.99963 8.08121 0 18 0C27.9188 0 36 7.99963 36 17.9174C36 28.0674 32.0597 35.6774 28.1594 40.7006C26.2137 43.2066 24.2662 45.0868 22.7902 46.3516C22.0505 46.9854 21.424 47.4692 20.9679 47.8038C20.7396 47.9713 20.5535 48.1018 20.4165 48.1956C20.3481 48.2424 20.2918 48.2802 20.2487 48.3087L20.1939 48.3447L20.1741 48.3576L20.1662 48.3627L20.1627 48.365ZM18 20.3119C19.3657 20.3119 20.4324 19.2176 20.4324 17.9174C20.4324 16.6173 19.3657 15.5229 18 15.5229C16.6343 15.5229 15.5676 16.6173 15.5676 17.9174C15.5676 19.2176 16.6343 20.3119 18 20.3119ZM24.4324 17.9174C24.4324 21.449 21.5525 24.3119 18 24.3119C14.4475 24.3119 11.5676 21.449 11.5676 17.9174C11.5676 14.3858 14.4475 11.5229 18 11.5229C21.5525 11.5229 24.4324 14.3858 24.4324 17.9174Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18 45C18 45 32 36.0208 32 17.9174C32 10.231 25.732 4 18 4C10.268 4 4 10.231 4 17.9174C4 36.0208 18 45 18 45ZM24.4324 17.9174C24.4324 21.449 21.5525 24.3119 18 24.3119C14.4475 24.3119 11.5676 21.449 11.5676 17.9174C11.5676 14.3858 14.4475 11.5229 18 11.5229C21.5525 11.5229 24.4324 14.3858 24.4324 17.9174Z" fill="${this.labels[serviceID] ? this.labels[serviceID].color : this.colors[0].value}"/></svg>`;
    return {
      scale,
      url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(svg),
      anchor: new google.maps.Point(width / 2 * scale, height * scale),
    };
  }

  setMinimalZoom() {
    const zoom = Math.min(this.map.getZoom(), this.constructor.MIN_ZOOM);
    this.map.setZoom(zoom);
  }

  setMap(message, center, points = []) {
    if (this.userAddress) {
      if (this.addressMarker) {
        this.addressMarker.setPosition(this.userAddress);
        this.addressMarker.setVisible(true);
      } else {
        this.addressMarker = this.getAddressMarker();
      }
    } else if (this.addressMarker) {
      this.addressMarker.setVisible(false);
    }

    if (this.userLocation) {
      // If user location available then the center parameter is equal to its position
      if (this.userMarker) {
        this.userMarker.setPosition(this.userLocation);
      } else {
        this.userMarker = this.getUserMarker();
      }

      this.markers.push(this.userMarker);

      // Reset user location for next requests
      this.userLocation = null;
    }

    if (points.length > 0) {
      // Show points
      this.$map.parent().removeClass('hidden');
      this.$noPudo.addClass('hidden');

      this.$title.text(i18n('Your nearest drop-off points'));
      this.createLabels(points);
      this.addPoints(points);
      this.setMinimalZoom();
    } else {
      this.$map.parent().addClass('hidden');
      if ($('.courier').length) {
        this.$noPudo.removeClass('hidden');
      }

      if (message) {
        // Address not found - show full country
        this.getCountryBounds().done((countryBounds) => {
          this.$title.text(message);
          this.map.fitBounds(countryBounds);
          this.map.setZoom(this.map.getZoom() + 1);
        }).fail(error => warn(error));
      } else {
        // Points not found - show map center and user marker on it (if available)
        this.$title.text(i18n('Drop-off points not found'));
        this.map.setCenter(center || this.center);
        this.setMinimalZoom();
      }
    }
  }

  createLabels(points) {
    this.labels = {};
    this.colors = [
      { value: '#E72F70' },
      { value: '#46BABA' },
      { value: '#D5E223' },
      { value: '#C372B2' },
      { value: '#E7504C' },
      { value: '#F27134' },
      { value: '#41CC8D' },
      { value: '#FDF1F6' },
      { value: '#EC4E9C' },
      { value: '#6856CA' },
      { value: '#070708' },
    ];

    const serviceIds = [...new Set(points.map((point) => point.service))];

    serviceIds.forEach((serviceID, index) => {
      const color = this.colors[index % this.colors.length];
      this.labels[serviceID] = { color: color.value };
    });
  }

  addPoints(points) {
    let $offices = $();

    points.forEach((point) => {
      let marker = null;
      const $office = $(parseTemplate(this.officeTemplate, point));

      if (point.lat !== null && point.lng !== null) {
        const position = new google.maps.LatLng(point.lat, point.lng);

        marker = new google.maps.Marker({
          map: this.map,
          position,
          draggable: false,
          icon: this.getIcon(point.service),
          title: point.title,
          $office,
        });

        marker.addListener('click', () => {
          const currentOfficePosition = $office.position().top - 5;
          if (this.lastOfficePosition === currentOfficePosition) {
            return;
          }
          const $scroller = this.$list.parent();
          $scroller.scrollTop(0);
          $scroller.animate({
            scrollTop: $scroller.scrollTop() + currentOfficePosition,
          }, 500);

          this.lastOfficePosition = currentOfficePosition;
        });

        this.markers.push(marker);
      }

      $office.data('office', new Office($office, marker, 'select_shop'));
      $offices = $offices.add($office);
    });

    this.markerCluster.addMarkers(this.markers);

    this.$list.append($offices);
    const latLngBounds = this.markers.reduce((bounds, marker) => {
      bounds.extend(marker.position);
      return bounds;
    }, new google.maps.LatLngBounds());

    if (this.userAddress && this.addressMarker) {
      latLngBounds.extend(this.addressMarker.position);
    }

    this.map.setCenter(latLngBounds.getCenter());
    // Show all markers for the proper clustering (should be fixed when markers outside
    // the viewport will automatically hide)
    this.map.fitBounds(latLngBounds);

    google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
      this.setMinimalZoom();
    });
  }

  clear() {
    this.$list.empty();
    if (this.markerCluster) {
      this.markerCluster.clearMarkers();
    }
    this.markers = [];
  }

  refresh(position, types) {
    if (this.finder) {
      // For drop-off points finder
      this.map.setZoom(this.constructor.MIN_ZOOM);
      this.setMap(false, position);
    } else {
      // For select shipping
      const searchString = $.trim(this.$search.val());
      const data = {};

      if (this.$search.is('input')) {
        // If search input is textbox then looking for the free-form address
        data.address = searchString;
      } else {
        // If search input is dropdown (for Hong Kong and Malta) then zip is explicitly known
        data.zip = searchString;
      }

      if (types) {
        // User has selected an option from Google SearchBox
        if (types.indexOf('country') !== -1) {
          data.type = 'country';
        }

        if (types.indexOf('continent') !== -1) {
          data.type = 'continent';
        }
      }

      // If the search request is different from the previous one then get new points
      // Order of properties is constant so we can use JSON.stringify for simplicity
      if (JSON.stringify(this.prevRequest) !== JSON.stringify(data)) {
        this.$gps.prop('disabled', true);
        this.constructor.toggleButton(this.$reload, true, i18n('Looking for new drop-off points...'));

        const settings = {
          url: '/main/get_new_marks_for_map',
          method: 'GET',
          data,
          dataType: 'json',
          noPreloader: true,
        };
        const debugSettings = {
          page: 'shipping',
          actions: ['not-found', 'points', 'no-points'],
          noNext: true,
        };

        $.ajax(ajaxSettings(settings, debugSettings)).done(
          /**
           * @param {{
           *   error: string|undefined,
           *   map_center: [number, number]|undefined,
           *   map_marks: Array<{
           *     id: number,
           *     carrier: number,
           *     service: number,
           *     title: string,
           *     address: string,
           *     hours: string,
           *     lat: number|null,
           *     lng: number|null,
           *   }>|undefined,
           * }} json Response of `action_get_new_marks_for_map()`: either `{error}` on failure,
           *   or `{map_marks, map_center?}` (with the fields listed above) on success.
           */
          (json) => {
            this.clear();

            if (json.map_center) {
              this.userAddress = new google.maps.LatLng(json.map_center[0], json.map_center[1]);
            } else {
              this.userAddress = null;
            }

            this.setMap(json.error, position, json.map_marks);
            this.prevRequest = data;

            this.onRefresh();
          },
        ).always(() => {
          this.$gps.prop('disabled', false);
          this.constructor.toggleButton(this.$reload, false, i18n('Look for new drop-off points'));
        });
      }
    }
  }

  handleReload() {
    this.$reload.on(`click${this.constructor.NAMESPACE}`, () => this.refresh());

    if (this.$search.is('select')) {
      this.$search.on(`change${this.constructor.NAMESPACE}`, () => this.refresh());
    }
  }

  handlePlaceChanges(widget, eventName, placeResolver) {
    widget.addListener(eventName, () => {
      const place = placeResolver();
      if (place) {
        // If user have chosen any element from search results then reload map
        this.refresh(place.geometry.location, place.types);
      }
    });
  }

  handleAutocomplete() {
    if (this.$search.is('input')) {
      let searchWidget;
      switch (this.searchWidgetClass) {
        case 'Autocomplete':
          searchWidget = new google.maps.places.Autocomplete(this.$search[0], {
            fields: ['geometry.location', 'types'],
          });
          searchWidget.bindTo('bounds', this.map);
          this.handlePlaceChanges(searchWidget, 'place_changed', () => searchWidget.getPlace());
          break;

        default:
          searchWidget = new google.maps.places.SearchBox(this.$search[0]);
          searchWidget.bindTo('bounds', this.map);
          this.handlePlaceChanges(searchWidget, 'places_changed', () => {
            const places = searchWidget.getPlaces();
            return (places.length !== 0) ? places[0] : null;
          });
      }

      this.$search.on(`keydown${this.constructor.NAMESPACE}`, (event) => {
        if (event.keyCode === 13) {
          // Don't send a full form if user pressed "Enter" key
          event.preventDefault();

          // If user enters some text and search results is empty then reload map
          const isSearchResultsHidden = !$('.pac-container:visible').length;
          if (isSearchResultsHidden) {
            this.refresh();
          }
        }
      });
    }
  }

  handleUserLocation() {
    this.userLocation = null;
    this.userMarker = null;

    if (window.navigator.geolocation) {
      this.$search.addClass('location-search__input_gps');

      this.$gps.on(`click${this.constructor.NAMESPACE}`, (event) => {
        event.preventDefault();

        this.$gps.removeClass(this.constructor.GPS_ERROR);
        this.constructor.toggleButton(this.$gps, true, i18n('Looking for your position...'));

        navigator.geolocation.getCurrentPosition((position) => {
          // Get user location
          this.userLocation = new google.maps.LatLng(
            position.coords.latitude, position.coords.longitude,
          );

          this.geocoder.geocode({
            latLng: this.userLocation,
          }, (results, status) => {
            this.constructor.toggleButton(this.$gps, false, i18n('Find near my location'));

            if (status === google.maps.GeocoderStatus.OK && results[0]) {
              this.$search.filter('input').val(results[0].formatted_address);
              this.refresh(this.userLocation);
            }
          });
        }, (error) => {
          warn(error.message);

          let message;
          let isError = false;
          switch (error.code) {
            case 1: // PERMISSION_DENIED
              message = i18n('User denied Geolocation');
              isError = true;
              break;
            case 2: // POSITION_UNAVAILABLE
              message = i18n('Position unavailable');
              isError = true;
              break;
            case 3: // TIMEOUT
              message = i18n('Timeout expired');
              break;
            default: // Something else
              message = i18n('Unexpected error');
              break;
          }

          this.$gps.toggleClass(this.constructor.GPS_ERROR, isError);
          this.constructor.toggleButton(this.$gps, false, message);
        }, { timeout: 5000 });
      });
    }
  }

  static toggleButton($button, isDisabled, message) {
    $button
      .prop('disabled', isDisabled)
      .attr('title', message)
      // .attr('aria-label', message);
      .find('.hidden_sr')
      .text(message);
  }
}

Location.NAMESPACE = '.location';
Location.MIN_ZOOM = 17;
Location.GPS_ERROR = 'location-search__button_gps_error';
Location.INFO_WINDOW = 'info-window';

export default Location;
